import { render, staticRenderFns } from "./clozeTest.vue?vue&type=template&id=35c33301&scoped=true&"
import script from "./clozeTest.vue?vue&type=script&lang=js&"
export * from "./clozeTest.vue?vue&type=script&lang=js&"
import style0 from "./clozeTest.vue?vue&type=style&index=0&id=35c33301&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c33301",
  null
  
)

export default component.exports